import debug from "debug";
const log = debug("volcengine-iframe");
function debugLogWithTime(msg) {
  const time = /* @__PURE__ */ new Date();
  log(`[debug] [time:${time.toLocaleString()}] ${msg}`);
}
export {
  debugLogWithTime,
  log
};
